import React, { useState, useMemo } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
import { BannerData } from "types/models/master/MasterApp";
import AppTableContainer from "@crema/core/AppTableContainer";

interface BannerTableProps {
  banners: BannerData[];
}

const BannerTable: React.FC<BannerTableProps> = ({ banners }) => {
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof BannerData>("title");

  const handleSort = (property: keyof BannerData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedBanners = useMemo(() => {
    return [...banners].sort((a, b) => {
      const aVal = a[orderBy];
      const bVal = b[orderBy];

      if (aVal == null) return 1;
      if (bVal == null) return -1;

      if (typeof aVal === "string") {
        return order === "asc"
          ? aVal.localeCompare(bVal as string)
          : (bVal as string).localeCompare(aVal);
      }

      if (typeof aVal === "number") {
        return order === "asc"
          ? (aVal as number) - (bVal as number)
          : (bVal as number) - (aVal as number);
      }

      if (typeof aVal === "boolean") {
        return order === "asc"
          ? Number(aVal) - Number(bVal)
          : Number(bVal) - Number(aVal);
      }

      return 0;
    });
  }, [banners, order, orderBy]);

  return (
    <AppTableContainer>
      <Table stickyHeader>
        <TableHead>
          <TableHeading order={order} orderBy={orderBy} onSort={handleSort} />
        </TableHead>
        <TableBody>
          {sortedBanners.map((data) => (
            <TableItem data={data} key={data.id} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default BannerTable;
